module.exports = __webpack_public_path__ + "static/media/iveco-lanczos3.aa8495dd.png";